import {
  HIERARCHY,
  HIERARCHY_CHECKED,
  HIERARCHY_CLEAR,
} from '../action-types/hierarchy-types';

export const initialState = {
  loading: false,
  hierarchy: [],
  hierarchy_checked: [],
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case HIERARCHY.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HIERARCHY.SUCCESS:
      return {
        ...state,
        hierarchy: action.payload.data,
        loading: false,
      };
    case HIERARCHY.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case HIERARCHY_CHECKED.SUCCESS:
      return {
        ...state,
        hierarchy_checked: action.payload,
      };
    case HIERARCHY_CLEAR:
      return {
        ...state,
        hierarchy_checked: [],
      };
    default:
      return state;
  }
}
